import { notifyError } from 'shared/errors/notificate.ts'

import { api } from '../api/api.js'
import { leftSideActions } from '../redux/reducers/leftSideMenu.ts'
import store from '../redux/store.ts'

export const imports = {
	editImports: async (
		item: Parameters<typeof leftSideActions.updateListName>[0]
	) => {
		try {
			await api.editImportsApi(item)

			store.dispatch(leftSideActions.updateListName(item))
		} catch (error) {
			notifyError(error)
		}
	}
}
